import React from 'react';

import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Pagination from '@mui/material/Pagination';

import styles from './TableWrapper.module.css';

function TableWrapper(props) {
  return (
    <div className={`${styles.tableWrapper} ${ props.isFetching && props.rows?.length ? styles.tableDisabled : ''}`} >
      { props.filter? props.filter: null }
      { props.rows
          ? <div className={styles.table}>
              { props.rows.length
                  ? props.children
                  : <Alert severity="warning">{props.emptyAlertText}</Alert>
              }
            </div>
          : <Box sx={{ display: 'flex', justifyContent: 'center' }}><CircularProgress /></Box>
      }
      { props.rows?.length
          ? <div>
              <Pagination
                color="primary"
                size="middle"
                count={props.count}
                page={parseInt(props.page, 10)}
                onChange={props.onChange}
                disabled={props.isFetching}
                sx={{display: 'flex', justifyContent: 'center'}}
              />
            </div>
          : null
      }
    </div>
  );
}

export default TableWrapper;
